import { Check, Compass, X } from "lucide-react";
import { useSite, tx } from "@/lib/lang";
import { ui } from "@/lib/uiStrings";
import { Reveal, SectionLabel } from "./Reveal";

export default function ChiEthic() {
  const { content, lang } = useSite();
  const t0 = ui[lang].chiSiamo;
  const c = content.chi_siamo || {};
  const t = {
    heading: tx(c.heading, lang) || t0.heading,
    p1: tx(c.p1, lang) || t0.p1,
    p2: tx(c.p2, lang) || t0.p2,
    badge: tx(c.badge, lang) || t0.badge,
    bullets: c.bullets?.[lang] || c.bullets?.it || t0.bullets,
    nonSiamo: c.nonSiamo?.[lang] || c.nonSiamo?.it || t0.nonSiamo,
    finale: tx(c.finale, lang) || t0.finale,
  };

  return (
    <section id="chi-siamo" data-testid="chi-e-ethic-section" className="py-16 lg:py-24">
      <div className="mx-auto max-w-7xl px-6 grid lg:grid-cols-2 gap-16 items-start">
        <div className="lg:sticky lg:top-28">
          <Reveal>
            <SectionLabel>{ui[lang].labels.chiSiamo}</SectionLabel>
            <h2 className="mt-5 font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-snug text-ice">
              {t.heading}
            </h2>
            <p className="mt-6 text-base text-muted-foreground leading-relaxed">{t.p1}</p>
            <p className="mt-4 text-base text-muted-foreground leading-relaxed">{t.p2}</p>
          </Reveal>
        </div>
        <Reveal delay={0.15}>
          <div data-testid="cabina-regia-card" className="bg-surface border border-ice/8 rounded-2xl p-8 lg:p-10">
            <div
              data-testid="advisor-badge"
              className="inline-flex items-center gap-2 bg-royal/15 border border-royal/40 text-azure font-mono text-xs uppercase tracking-[0.2em] rounded-full px-4 py-1.5"
            >
              <Compass size={14} />
              {t.badge}
            </div>
            <ul className="mt-8 space-y-5">
              {t.bullets.map((b, i) => (
                <li key={i} className="flex items-start gap-3.5">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-royal/20 text-azure">
                    <Check size={13} />
                  </span>
                  <span className="text-sm text-ice/85 leading-relaxed">{b}</span>
                </li>
              ))}
            </ul>
            <div className="mt-8 border-t border-ice/8 pt-6">
              <ul className="space-y-3">
                {(t.nonSiamo || []).map((n, i) => (
                  <li key={i} className="flex items-start gap-3 text-sm text-muted-foreground">
                    <X size={14} className="mt-0.5 shrink-0 text-red-400/70" />
                    {n}
                  </li>
                ))}
              </ul>
              <p className="mt-5 flex items-start gap-3 text-sm font-semibold text-azure">
                <Check size={15} className="mt-0.5 shrink-0" />
                {t.finale}
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
